<template>
    <div>
        <div class="charts-container">
            <CustomerPieChart v-show="!loading" :valueList="hourList"></CustomerPieChart>
            <b-skeleton type="avatar" v-if="loading" class="skeleton-size"></b-skeleton>
        </div>

        <b-table
            :fields="fields"
            :items="items"
            :class="['gk-table gk-table--responsive gk-table--striped gk-table--headed']"
            :busy="loading"
            :tbody-tr-class="rowClass"
            show-empty
            table-busy>
            <template #cell(name)="row">
                <span>{{ row.value }}</span>
                &nbsp;
                <font-awesome-icon v-if="row.item.is_archived" icon="fa-solid fa-folder" />
            </template>
            <template #head(name)>
                <translate>Customer</translate>
                &nbsp;
                <GekkoButton
                    @click="sortByName"
                    :icon="sortNameDesc ? 'fa fa-arrow-down-z-a' : 'fa fa-arrow-up-z-a'"
                    class="p-0 sort-icon-class"
                    variant="link"
                />
            </template>
        </b-table>
    </div>
</template>

<script>
import HourService from '@/store/services/hour.service'
import CustomerPieChart from '@/components/customer_insight/CustomerPieChart'

export default {
    name: "InsightHoursTable",
    components: {CustomerPieChart},
    data() {
        return {
            items: [],
            fields: [
                { key: 'name', label: this.$gettext('Customer')},
                { key: 'invoiced', label: this.$gettext('Invoiced'), thClass: 'th-class', tdClass: 'td-class', sortable: true},
                { key: 'uninvoiced', label: this.$gettext('Uninvoiced'), thClass: 'th-class', tdClass: 'td-class', sortable: true},
                { key: 'totals', label: this.$gettext('Totals'), thClass: 'th-class', tdClass: 'td-class', sortable: true}
            ],
            sortNameDesc: false,
            loading_customers: true,
            loading_filters: true
        }
    },
    props: {
        customers: {
            type: Array,
            default: () => []
        },
        filters: {
            type: Object,
            default: () => {}
        }
    },
    watch: {
        customers() {
            this.loading_customers = true
            this.setReportData('customers')
        },
        filters() {
            this.loading_filters = true
            this.setReportData('filters')
        }
    },
    methods: {
        setReportData(loading_type) {
            if (this.$store.getters['getIsPremium']) {
                if (this.customers.length)
                    this.setRealData(loading_type)
            } else
                this.setFakeData(loading_type)
        },
        setRealData(loading_type) {
            let api_filters = {
                'start_date': this.filters.start_date,
                'end_date': this.filters.end_date,
                group_by: 'project__company'
            }

            let filters_invoiced = {
                'start_date': this.filters.start_date,
                'end_date': this.filters.end_date,
                group_by: 'project__company',
                is_invoiced: 'True'
            }

            let temp_data = []
            this.items = []
            let customers_copy = JSON.parse(JSON.stringify(this.customers))
            
            HourService.getTotalAmountV2(api_filters).then((response) => {
                temp_data = this.mergeTwoLists(customers_copy, response.data, 'id', 'project__company', 'total_amount', 'total')

                HourService.getTotalAmountV2(filters_invoiced).then((response) => {
                    temp_data = this.mergeTwoLists(temp_data, response.data, 'id', 'project__company', 'total_invoiced', 'total')
                    
                    for(let i in temp_data) {
                        if (isNaN(temp_data[i].total_invoiced))
                            temp_data[i].total_invoiced = 0

                        if(isNaN(temp_data[i].total_amount))
                            temp_data[i].total_amount = 0
                        
                        this.items.push({
                            'id': temp_data[i].id,
                            'name': temp_data[i].name,
                            'invoiced': this.$options.filters.amount2HourMin(temp_data[i].total_invoiced, this.$gettext("H"), this.$gettext("M")),
                            'uninvoiced': this.$options.filters.amount2HourMin(temp_data[i].total_amount - temp_data[i].total_invoiced, this.$gettext("H"), this.$gettext("M")),
                            'totals_numbr': temp_data[i].total_amount,
                            'totals': this.$options.filters.amount2HourMin(temp_data[i].total_amount, this.$gettext("H"), this.$gettext("M")),
                            'is_archived': temp_data[i].is_archived
                        })
                    }

                    this.items = this.items.filter((item) => item['totals_numbr'] > 0)
                    this.loading_customers = false
                    this.loading_filters = false
                })
            })
        },
        setFakeData(loading_type) {
            this.items = []
            
            for(let i = 1; i <= 4; i++) {
                this.items.push({
                    'name': `${this.$gettext("fake customer")} ${i}`,
                    'invoiced': this.$options.filters.amount2HourMin((1 * i), this.$gettext("H"), this.$gettext("M")),
                    'uninvoiced': this.$options.filters.amount2HourMin((2 * i) - (1 * i), this.$gettext("H"), this.$gettext("M")),
                    'totals': this.$options.filters.amount2HourMin((2 * i), this.$gettext("H"), this.$gettext("M")),
                    'totals_numbr': (2 * i)
                })
            }

            if (loading_type === 'customers')
                this.loading_customers = false
            if (loading_type === 'filters')
                this.loading_filters = false
        },
        mergeTwoLists(list1, list2, ifProp1, ifProp2, prop1, prop2) {
            let finalList = list1.map((x) => x)
            for(let i in finalList) {
                for (let j in list2) {
                    if (finalList[i][ifProp1] == list2[j][ifProp2]) {
                        finalList[i][prop1] = list2[j][prop2]
                    }
                }
            }
            return finalList
        },
        sortByName() {
            if (this.sortNameDesc) {
                this.items.sort((a, b) => {
                    const nameA = a.name.toUpperCase()
                    const nameB = b.name.toUpperCase()

                    if (nameA < nameB) {
                        return -1
                    }

                    if (nameA > nameB) {
                        return 1
                    }

                    return 0
                })
            } else {
                this.items.sort((a, b) => {
                    const nameA = a.name.toUpperCase();
                    const nameB = b.name.toUpperCase();

                    if (nameA > nameB) {
                        return -1
                    }

                    if (nameA < nameB) {
                        return 1
                    }

                    return 0
                })
            }

            this.sortNameDesc = !this.sortNameDesc
        },
        rowClass(item) {
            if (item && item.is_archived)
                return "archived-row"
            return ""
        }
    },
    computed: {
        hourList() {
            return this.items.filter((item) => item.totals_numbr > 0).map((item) => { return {'label': item.name, 'value': item.totals_numbr}})
        },
        loading() {
            return this.loading_customers || this.loading_filters
        }
    }
}
</script>

<style scoped>
.charts-container {
    padding-top: 1rem;
    padding-bottom: 1rem;
    display: flex;
    width: 100%;
    justify-content: center;
    overflow: auto;
}

.skeleton-size {
    min-width: 180px;
    width: 450px;
    height: 450px;
}
</style>

<style>
.th-class {
    text-align: right;
}

.td-class {
    text-align: right;
}

.sort-icon-class:hover {
    color: #3f444d;
}

.archived-row {
    color: #bbb;
}
</style>